import React from 'react';
import BaseTasksPage from './BaseTasksPage';
import { NextButton, PreviousButton } from './Buttons';
import useLaunchProjectNavigator from './launchProjectNavigator';

export default function ManageAllTasksPage() {
  const navigator = useLaunchProjectNavigator();

  return (
    <BaseTasksPage
      buttons={[
        <PreviousButton onClick={navigator.openKeyDateTasksPage} key="previous-button" />,
        <NextButton onClick={navigator.openTransactionPartiesPage} key="next-button" />,
      ]}
      stepNumber={3}
    />
  );
}
